<template>
  <AuthLayout>
    <div class="flex justify-content-center align-items-center w-full h-full">
      <div class="register-page">
        <h1 class="text-center H5-SemiBold">Join with us to become a bright student</h1>

        <Form v-slot="$form" @submit="handleRegister" :initialValues="initialValues" :resolver="resolver"
          class=" register-form justify-content-center align-items-center">
          <div class="flex flex-column  gap-3 pt-4">
            <label for="username" class="Label align-self-start">Full Name</label>
            <IconField class="w-full">
              <InputIcon class="pi pi-user" />
              <InputText name="username" type="text" placeholder="Enter full name here" size="small" variant="filled"
                class="w-full" />
            </IconField>
            <Message v-if="$form.username?.invalid" severity="error" size="small" variant="simple">
              {{ $form.username?.error.message }}</Message>
          </div>
          <div class="flex flex-column  gap-3 pt-4">
            <label for="email" class="Label align-self-start">Email</label>
            <IconField class="w-full">
              <InputIcon class="pi pi-user" />
              <InputText name="email" type="text" placeholder="Enter email here" size="small" variant="filled"
                class="w-full" />
            </IconField>
            <Message v-if="$form.email?.invalid" severity="error" size="small" variant="simple">
              {{ $form.email.error.message }}</Message>
          </div>
          <div class="flex flex-column  gap-3 pt-4 ">
            <label for="password" class="Label align-self-start"> Password</label>
            <IconField iconPosition="left" class="w-full">
              <InputIcon class="pi pi-lock" />
              <Password name="password" type="password" toggleMask placeholder="Enter password here" size="small"
                variant="filled" class="w-full" />
            </IconField>
            <Message v-if="$form.password?.invalid" severity="error" size="small" variant="simple">
              {{ $form.password.error.message }}</Message>
          </div>
          <div class="flex align-items-start w-full py-4">
            <div class="flex items-start gap-2 ">
              <Checkbox v-model="termsChecked" binary @change="onTermsChange"/>
              <label class="Caption align-self-center"> Yes, I understand and agree to the iLearned Tutoring Terms of
                Service, including the User Agreement and Privacy Policy. </label>
            </div>
            
          </div>
          <Message v-if="!termsChecked && formSubmitted" severity="error" size="small" variant="simple" class="w-full">
            You must accept the Terms of Service to register.
          </Message>
          <div class="flex flex-column align-items-center gap-3 pt-4 ">
            <Button type="submit" class="teal-button" :disabled="loading">
              {{ loading ? "Creating..." : "Create my account" }}
            </Button>
            <label for="username" class="Caption pt-2">Already have an account? <span
                class="Caption-teal cursor-pointer" @click="SignUp">Login</span></label>
          </div>
        </Form>
      </div>
    </div>
  </AuthLayout>
</template>

<script setup>
import AuthLayout from "@/layout/AuthLayout.vue";
import { ref, reactive } from "vue";
import { useAuthStore } from "@/stores/authStore";
import { Form } from '@primevue/forms';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import Message from 'primevue/message';
import router from '@/router';

const authStore = useAuthStore();

const loading = ref(false);
const termsChecked = ref(false);
const formSubmitted = ref(false);
const initialValues = reactive({
  username: '',
  email: '',
  password: '',
 
});

const handleRegister = async (values) => {
  formSubmitted.value = true;
if (!termsChecked.value) {
    return; 
  }
  loading.value = true;
  router.push('./onBoarding');
  try {
    await authStore.register({
      username: values.username,
      email: values.email,
      password: values.password,

    });
    

  } catch (err) {
    loading.value = false;
  } finally {
    loading.value = false;
  }
};

const resolver = ({values}) => {
  const errors = {};

  if (!values.username) {
    errors.username = [{ message: 'Username is required.' }];
  }

  if (!values.email) {
    errors.email = [{ message: 'Email is required.' }];
  }

  if (!values.password) {
    errors.password = [{ message: 'Password is required.' }];
  }
  
  return {
    values,
    errors
  };
};
</script>

<style scoped>
.register-page {
  width: 550px;
  max-width: 100%;
  padding: 2rem;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

@media (max-width: 768px) {
  .register-page {
    width: 100%;
    margin-bottom: 1rem;
  }
}
</style>
